import { UPDATE_TRANSFER, REMOVE_TRANSFER } from "@actions/transfers/"

export const updateTransfer = (key, value, uuid) => dispatch => dispatch({ type: UPDATE_TRANSFER, uuid, key, value })

export const removeTransfer = uuid => dispatch => dispatch({ type: REMOVE_TRANSFER, uuid })
